import { graphql } from 'gql'

export const TOGGLE_FILTERING_RULE = graphql(`
  mutation toggleFilteringRule($input: ToggleFilteringRuleInput!) {
    toggleFilteringRule(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
